import { useState , useEffect} from "react"
import { RegistrationForm } from "../components/Beneficiary/RegistrationForm"
import { WalletForm } from "../components/Beneficiary/WalletForm"




export const Beneficiary = () => {
    const [form, setForm] = useState(false);
    const [isDark, setIsDark] = useState(
        () =>
          typeof window !== "undefined" && document.body.classList.contains("dark")
      );
    
      useEffect(() => {
        const checkDark = () => setIsDark(document.body.classList.contains("dark"));
        checkDark();
        const observer = new MutationObserver(() => {
          checkDark();
        });
        observer.observe(document.body, {
          attributes: true,
          attributeFilter: ["class"],
        });
        return () => {
          observer.disconnect();
        };
      }, []);
    
    return (
        <div className="w-full h-screen bg-white dark:bg-[#0D1117]">
       <div className="mb-6 p-3 lg:p-6">
      
         <h1
  className="
    relative inline-block text-3xl font-bold mb-6 
    text-[#0010c6] dark:text-white
    after:content-[''] after:block after:w-full after:h-[4px] 
    after:bg-[#0010c6] after:mt-[10px] dark:after:bg-[#ffffff]
  "
>
ذینفع ها 
</h1>
       
      </div>  
        <div className="col-span-full my-8 flex flex-col">
            <div className="tabs flex justify-center mx-auto p-3">
                <div className={`tab-item inline px-2 cursor-pointer ${form ? '' : 'active'}`} onClick={() => setForm(false)}><span>حساب بانکی</span></div>
                {/* <div className={`tab-item inline px-2 cursor-pointer ${form ? 'active' : ''}`} onClick={() => setForm(true)}><span>کیف پول</span></div> */}
            </div>
            
            {form ? <WalletForm /> : <RegistrationForm />}
        </div>
        </div>
    )
}